import { anyOf, objectOf } from "@altostra/type-validations";
import { nullValidation, string } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailResult = objectOf({
  body: anyOf(string, nullValidation),
});
